// src/pages/CMS/CmsNoticeDetail.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../utils/cmsAxios";

const formatDate = (dateString) => {
    const d = new Date(dateString);
    if (isNaN(d)) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
};

const CmsNoticeDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { notice_no } = useParams();

    const [notice, setNotice] = useState(location.state?.notice || null);
    const [loading, setLoading] = useState(!location.state?.notice);
    const [err, setErr] = useState("");

    const fetchById = useCallback(async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/${notice_no}`);
            if (!data || data.notice_no == null) {
                setErr("공지사항을 찾을 수 없습니다.");
                return;
            }
            setNotice(data);
        } catch (e) {
            console.error(e);
            setErr("공지사항을 불러오는 데 실패했습니다.");
        } finally {
            setLoading(false);
        }
    }, [notice_no]);

     useEffect(() => {
        if (!notice) {
            setLoading(true);
            fetchById();
        }
    }, [notice, fetchById]);

    const handleEdit = () => {
        if (!notice?.notice_no) return;
        navigate(`/cms/notice/edit/${notice.notice_no}`, {
            state: { notice, type: "admin" }
    });
};

    const handleBackToList = () => {
        navigate("/cms/notice", { state: { type: "admin" } });
    };

    if (loading) {
        return <div className="p-4 text-gray-500">불러오는 중…</div>;
    }
    if (err) {
        return (
            <div className="p-4">
                <div className="mb-3 rounded-lg bg-red-50 text-red-700 px-3 py-2 text-sm">{err}</div>
                <button
                    onClick={handleBackToList}
                    className="rounded-lg border px-4 py-2 text-sm hover:bg-gray-50"
                >
                    목록
                </button>
            </div>
        );
    }
    if (!notice) return null;

    return (
        <div className="min-h-screen bg-neutral-50">
            <div className="mx-auto max-w-[1280px] bg-white rounded-2xl shadow-[0_0_0_1px_rgba(0,0,0,0.06),0_40px_80px_-24px_rgba(0,0,0,0.12)] overflow-hidden">
                <div className="flex">

                    {/* Right content */}
                    <div className="flex-1 min-w-0">

                        <main className="pt-12 flex flex-col p-4 overflow-x-hidden w-full">
                            <section className="p-4">
                                <div className="mb-3 flex items-center justify-between">
                                    <button
                                        onClick={handleBackToList}
                                        className="rounded-lg border px-4 py-2 text-sm hover:bg-gray-50"
                                    >
                                        목록
                                    </button>
                                    <button
                                        onClick={handleEdit}                 // ✅ 수정 이동
                                        className="rounded-lg border px-4 py-2 text-sm text-blue-600 hover:bg-blue-50"
                                    >
                                        수정
                                    </button>
                                    <span className="text-xl font-semibold mb-4 text-gray-400">
                                        {formatDate(notice.created_at)}
                                    </span>
                                </div>

                                <h2 className="text-2xl font-bold pb-4">{notice.notice_title}</h2>
                                <p className="text-gray-600 pb-4 whitespace-pre-line">{notice.notice_content}</p>
                                <p className="text-gray-400 text-sm pb-8">{formatDate(notice.created_at)}</p>
                            </section>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CmsNoticeDetail;
